import "./counter.css"

const Counter = (props) => {

    const {count, handleCountChange} = props
    
    

    

return (
    <input className="counter" type="number" value={count} onChange={handleCountChange}   />
    )
}
export default Counter
